import script from "./statistic-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./statistic-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./statistic-setting-ly.vue?vue&type=style&index=0&id=3c45f74c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c45f74c"]])

export default __exports__